export default __webpack_public_path__ + "umbrella-black-silhouette.png";